// extracted by mini-css-extract-plugin
export default {"detailForm":"DetailForm_detailForm__3gR7Q","media":"DetailForm_media__dOuk3"};